// import React from 'react'

// const ViewhoodReturnApproval = () => {
//   return (
//     <div>
      
//     </div>
//   )
// }

// export default ViewhoodReturnApproval


import * as React from "react";
import { useState, useEffect, useContext, useMemo } from "react";
import { AnyForNow, GrnData, GrnItem } from "./types";
import {
  AppBar,
  Typography,
  Button,
  Box,
  Breadcrumbs,
  Link,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { PageDataContext } from "../../utils/common/PageDataContext";
import ViewDataGridGrn from "../../components/grid/ViewDataGridGrn";
import { ViewApproverReturnGrnData } from "../../components/grid/GridDataGrn";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ApprovalActionDialog from "../../components/grn/grnpopup/ApprovalActionDialog";
import ApprovalActionDialogreturn from "../../components/grn/grnpopup/ApprovalActionDialogreturn";
import SystemAlert from "../../components/common/SystemAlert";
import FilterGrnSearch from "../../components/grn/FilterGrnSearch";
import { useSelector } from "react-redux";
import { externalgetApi } from "../../services/externalApis";
import { GRN_API_17 } from "../../api/ApiModel";
import { CON_YES } from "../../utils/sys/Constants";
import { FormatDate } from "../../utils/common/DateUtils";
import FilterReturnGrnSearch from "../../components/grn/FilterReturnGrnSearch";
import { useCallback } from "react";
import {
  useGrnStatusTypes,
  useWarehouseOptions,
} from "./hooks/useGrnFilters";

import {
  BUTTON_LABELS,
  GRN_BREADCRUMBS,
  PAGE_TITLES,
} from "../../utils/sys/GrnLabels";
import {
  GRN_ERROR_MESSAGES,
  GRN_SUCCESS_MESSAGES,
} from "../../utils/sys/GrnValidation";
import { GRN_ROUTES } from "../../utils/sys/GrnRoutes";
import {
  GRN_ALERT_TYPE,
  GRN_RETURN_APPROVAL_FILTER,
  GRN_RETURN_PROCESS_STATUS,
  GRN_RETURN_STATUS,
  PARAM_ID,
} from "../../utils/sys/GrnConstants";
import { SEARCH_FIELDS_RTNHISTORY } from "../../utils/sys/GrnSearchFeilds";

const ViewhoodReturnApproval: React.FC = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const { setPageData } = useContext(PageDataContext);

  useEffect(() => {
    setPageData({
      title: PAGE_TITLES.PURCHASE_APP_RETURN,
      // icon: <HomeIcon />,
      // showBackButton: false,
      // customActions: <button>Refresh</button>,
      // breadcrumbs: ["Home", "Dashboard"],
    });
  }, []);
  const [selectedIds, setSelectedIds] = useState<AnyForNow[]>([]);
  const [openRejectDialog, setOpenRejectDialog] = useState<boolean>(false);
  const [openApproveDialog, setOpenApproveDialog] = useState<boolean>(false);
  const [openReturnDialog, setOpenReturnDialog] = useState<boolean>(false);
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>("");
  const [alertType, setAlertType] = useState<string>(GRN_ALERT_TYPE.ERROR); // or "success", "info", etc.
  const SYS_USER = useSelector((state: AnyForNow) => state.user) || {};
  const { STAFFMAPLOCODE, USERNAME, COMPCODE } = SYS_USER.USER_PARAM || {};
  const moduleParamJson = useSelector((state: AnyForNow) => state.moduleParamJson);
  const moduleParamJsonArray = Array.isArray(moduleParamJson)
    ? moduleParamJson
    : Object.values(moduleParamJson || {});
  const isParaYes =
    moduleParamJsonArray.find((item) => item.PARAID === PARAM_ID.APPROVAL_WORKFLOW)
      ?.PARAVALUE === CON_YES;

  const warehouseOptions = useWarehouseOptions(COMPCODE);
  const excludedStatuses =
    GRN_RETURN_APPROVAL_FILTER.EXCLUDED_STATUSES as readonly string[];
  const returnStatusFilter = useCallback(
    (item: AnyForNow) => {
      if (String(item.trcatcode) !== GRN_RETURN_APPROVAL_FILTER.TRCATCODE) {
        return false;
      }
      return !excludedStatuses.includes(String(item.trsts));
    },
    [excludedStatuses]
  );
  const { statusTypes: grnStatusTypes } = useGrnStatusTypes({
    filter: returnStatusFilter,
    mapStatus: (item) => ({
      ...item,
      grnstatus: item.trappuserremark,
      grnstatuscode: item.trsts,
      colorcode: item.colorcode || GRN_RETURN_APPROVAL_FILTER.STATUS_FALLBACK_COLOR,
    }),
    deps: [returnStatusFilter],
  });

  const [allfullData, setAllfullData] = useState<AnyForNow[]>([]);
  const [filteredfullRows, setFilteredfullRows] = useState<AnyForNow[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  // Inside ViewApproverGrn

  const [selectedGrnCode, setSelectedGrnCode] = useState<AnyForNow[]>([]);
  const [selectedRtnCode, setSelectedRtnCode] = useState<AnyForNow[]>([]);

  const showSuccess = (msg: string) => {
    setAlertMessage(msg);
    setAlertType(GRN_ALERT_TYPE.SUCCESS);
    setAlertOpen(true);
  };

  // Button click handler
  const handleApproveClick = () => {
    if (selectedIds.length === 0) {
      showError(GRN_ERROR_MESSAGES.SELECT_AT_LEAST_ONE_GRN);
      return;
    }
    // setSelectedGrnCode(selectedIds[0]);
    setOpenApproveDialog(true);
  };
  const handleRejectClick = () => {
    if (selectedIds.length === 0) {
      showError(GRN_ERROR_MESSAGES.SELECT_AT_LEAST_ONE_GRN);
      return;
    }
    // setSelectedGrnCode(selectedIds[0]);
    setOpenRejectDialog(true);
  };

  const handleReturnClick = () => {
    if (selectedIds.length === 0) {
      showError(GRN_ERROR_MESSAGES.SELECT_AT_LEAST_ONE_GRN);
      return;
    }
    // setSelectedGrnCode(selectedIds[0]);
    setOpenReturnDialog(true);
  };

  // const handleRowSelection = (ids) => {
  //   setSelectedIds(ids);

  //   if (ids.length === 1) {
  //     const selectedRow = filteredRows.find((row) => row.id === ids[0]);
  //     if (selectedRow) {
  //       setSelectedGrnCode(selectedRow.grncode);
  //     }
  //   } else {
  //     setSelectedGrnCode("");
  //   }
  // };

 const handleRowSelection = (ids: AnyForNow) => {
  if (!ids.length) {
    setSelectedIds([]);
    setSelectedGrnCode([]);
    setSelectedRtnCode([]);
    return;
  }

  // Find all selected rows
  const selectedRows = filteredRows.filter((row) => ids.includes(row.id));

  // Get the trsts of the first selected row
  const firstStatus = selectedRows[0]?.trsts;

  // Check if all selected rows share the same trsts
  const allSameStatus = selectedRows.every((row) => row.trsts === firstStatus);

  if (!allSameStatus) {
    // Block selection of rows with mixed status
    console.warn("Selection blocked: Different status (trsts) detected.");
    setAlertMessage(GRN_ERROR_MESSAGES.SELECT_SAME_STATUS);
    setAlertType(GRN_ALERT_TYPE.ERROR);
    setAlertOpen(true);

    // Revert to previously valid selection
    return;
  }

  // Allowed â€” update selected rows and GRN codes
  setSelectedIds(ids);
  setSelectedGrnCode(selectedRows.map((row) => row.grncode));
  setSelectedRtnCode(selectedRows.map((row) => row.grnreturncode));
};


  const [allData, setAllData] = useState<AnyForNow[]>([]);
  const [filteredRows, setFilteredRows] = useState<AnyForNow[]>([]);
  const [filters, setFilters] = useState<AnyForNow>({
    grnId: "",
    warehouse: "",
    status: "",
    fromDate: null,
    toDate: null,
    grnreturncode: "",
  });
  const showError = (msg: string) => {
    setAlertMessage(msg);
    setAlertType(GRN_ALERT_TYPE.ERROR);
    setAlertOpen(true);
  };

  const handleItemClick = (row: AnyForNow, actionText: string) => {
    if (actionText === BUTTON_LABELS.VIEW) {
      navigate(GRN_ROUTES.VIEW_RETURN_GRN_DETAIL, {
        state: {
          grncode: row.grncode,
          trsts: row.trsts,
          origin: GRN_RETURN_APPROVAL_FILTER.ORIGIN,
          grnreturncode: row.grnreturncode,
          returneddate: row.returneddate,
        },
      });
    } else if (actionText === BUTTON_LABELS.EDIT) {
      navigate(GRN_ROUTES.EDIT, { state: { grncode: row.grncode, trsts: row.trsts, grnreturncode: row.grnreturncode, returneddate: row.returneddate } });
    }
  };
  // Refs to prevent duplicate API calls
  const hasFetchedGrnListRef = React.useRef(false);
  const grnStatusTypesRef = React.useRef<AnyForNow[]>([]);
  const isInitialLoadRef = React.useRef(true);

  // Update ref when grnStatusTypes changes
  React.useEffect(() => {
    grnStatusTypesRef.current = grnStatusTypes;
  }, [grnStatusTypes]);

  // Consolidated: Single API call that processes data for both filtered and full lists
  const fetchGrnListData = useCallback(async (forceRefresh = false): Promise<void> => {
    if (!COMPCODE || !STAFFMAPLOCODE) {
      return;
    }

    // Prevent duplicate calls unless forced refresh
    if (hasFetchedGrnListRef.current && !forceRefresh) {
      return;
    }

    try {
      hasFetchedGrnListRef.current = true;
   

      // Single API call instead of two duplicate calls
      const result = await externalgetApi(GRN_API_17, "GET", {
        COMPCODE,
        LOCCODE: STAFFMAPLOCODE,
        TRCATCODE: GRN_RETURN_APPROVAL_FILTER.TRCATCODE,
      });

      console.log("1",result)

      if (!Array.isArray(result)) {
        setAllfullData([]);
        setAllData([]);
        setFilteredRows([]);
     
        return;
      }

    

      // Filter out trsts 12 and 13 for full data
      const filteredResultAll = result.filter(
        (item) => !excludedStatuses.includes(String(item.trsts))
      );

      // Filter only trsts = 9 for initial display
      const filteredResultInitial = result.filter(
        (item) =>
          String(item.trsts) === GRN_RETURN_APPROVAL_FILTER.INITIAL_STATUS
      );

      // Process full data
      const rowsWithIdAll = filteredResultAll.map((item, index) => {
        const matchedStatus = grnStatusTypesRef.current.find(
          (status) => String(status.trsts) === String(item.trsts)
        );

        return {
          ...item,
        // AFTER — combine grncode + grnreturncode for a truly unique id
id: item.grnreturncode || index,
          invoicedate: FormatDate(item.invoicedate) || null,
          endate: FormatDate(item.endate) || null,
          statusLabel: matchedStatus?.trappuserremark || GRN_BREADCRUMBS.STATUS_FALLBACK,
          statusColor:
            matchedStatus?.colorcode || GRN_RETURN_APPROVAL_FILTER.STATUS_FALLBACK_COLOR,
          invoicedateRaw: item.invoicedate,
          endateRaw: item.endate,
          ponumber: item.ponumber,
          grnstatuscode: item.trsts,
          Supplier: `${item.suprefcode} - ${item.suppliername}`,
        };
      });

      // Process initial filtered data (trsts = 9)
      const rowsWithIdInitial = filteredResultInitial.map((item, index) => {
        const matchedStatus = grnStatusTypesRef.current.find(
          (status) => String(status.trsts) === String(item.trsts)
        );

        return {
          ...item,
          id: item.grnreturncode || index,
          invoicedate: FormatDate(item.invoicedate) || null,
          endate: FormatDate(item.endate) || null,
          statusLabel: matchedStatus?.trappuserremark || GRN_BREADCRUMBS.STATUS_FALLBACK,
          statusColor:
            matchedStatus?.colorcode || GRN_RETURN_APPROVAL_FILTER.STATUS_FALLBACK_COLOR,
          invoicedateRaw: item.invoicedate,
          endateRaw: item.endate,
          ponumber: item.ponumber,
          grnstatuscode: item.trsts,
           Supplier: `${item.suprefcode} - ${item.suppliername}`,
           lastupdateuser: item.lastupdateuser?.split("|")[0],
        };
      });

      setAllfullData(rowsWithIdAll);
      setAllData(rowsWithIdInitial);
      setFilteredRows(rowsWithIdInitial);
    } catch (err) {
      console.error("Error fetching GRN list data:", err);
      hasFetchedGrnListRef.current = false; // Reset on error to allow retry
    } finally {
    
    }
  }, [COMPCODE, STAFFMAPLOCODE]);

  // Initial load - only fetch when status types are loaded
  useEffect(() => {
    if (grnStatusTypes.length > 0 && isInitialLoadRef.current && COMPCODE && STAFFMAPLOCODE) {
      isInitialLoadRef.current = false;
      fetchGrnListData();
    }
  }, [fetchGrnListData, grnStatusTypes.length, COMPCODE, STAFFMAPLOCODE]);

const isFilterApplied = Object.values(filters).some(
  (val) => val !== null && val !== ""
);

// Replace your existing filter useEffect with this single consolidated one:

useEffect(() => {
  if (!allfullData.length && !allData.length) {
    setFilteredfullRows([]);
    setFilteredRows([]);
    return;
  }

  const applyFilters = (source: AnyForNow[]) => {
    let filtered = source;

    if (filters.search) {
      const search = filters.search.toLowerCase();
      filtered = filtered.filter((item) =>
        Object.values({
          grncode: item.grncode,
          grnreturncode: item.grnreturncode,
        
        }).some((val) => val?.toString().toLowerCase().includes(search))
      );
    }

    if (filters.grnId) {
      const search = filters.grnId.toLowerCase();
      filtered = filtered.filter((item) =>
        item.grncode.toString().toLowerCase().includes(search)
      );
    }

    if (filters.grnreturncode) {
      const search = filters.grnreturncode.toLowerCase();
      filtered = filtered.filter((item) =>
        item.grnreturncode?.toString().toLowerCase().includes(search)
      );
    }

    if (filters.warehouse) {
      filtered = filtered.filter(
        (item) => String(item.restcode) === String(filters.warehouse)
      );
    }

    if (filters.status) {
      filtered = filtered.filter(
        (item) => String(item.grnstatuscode) === String(filters.status)
      );
    }

    if (filters.fromDate && filters.toDate) {
      const from = new Date(filters.fromDate);
      const to = new Date(filters.toDate);
      const start = from < to ? from : to;
      const end = from < to ? to : from;
      filtered = filtered.filter((item) => {
        const date = new Date(item.invoicedateRaw || item.endateRaw);
        return date >= start && date <= end;
      });
    } else if (filters.fromDate) {
      const from = new Date(filters.fromDate);
      filtered = filtered.filter(
        (item) => new Date(item.invoicedateRaw) >= from
      );
    } else if (filters.toDate) {
      const to = new Date(filters.toDate);
      filtered = filtered.filter(
        (item) => new Date(item.endateRaw) <= to
      );
    }

    return filtered;
  };

  // Apply filters to BOTH datasets so both grid paths respond to search
  setFilteredfullRows(applyFilters(allfullData));
  setFilteredRows(applyFilters(allData));   // ← this was the missing piece

}, [filters, allfullData, allData]);

  const handleFilterChange = (newFilters: AnyForNow) => {
    setFilters(newFilters);
  };

  // Sort rows by GRN Date in descending order (newest first)
  const sortedFilteredRows = useMemo(() => {
    return [...filteredRows].sort((a, b) => {
      const dateA = a.endateRaw ? new Date(a.endateRaw).getTime() : 0;
      const dateB = b.endateRaw ? new Date(b.endateRaw).getTime() : 0;
      return dateB - dateA; // Descending order (newest first)
    });
  }, [filteredRows]);

  const sortedFilteredFullRows = useMemo(() => {
    return [...filteredfullRows].sort((a, b) => {
      const dateA = a.endateRaw ? new Date(a.endateRaw).getTime() : 0;
      const dateB = b.endateRaw ? new Date(b.endateRaw).getTime() : 0;
      return dateB - dateA; // Descending order (newest first)
    });
  }, [filteredfullRows]);

  const menuItems = [
    {
      text: BUTTON_LABELS.VIEW,
      icon: <VisibilityOutlinedIcon />,
      onClick: (row: AnyForNow) => handleItemClick(row, BUTTON_LABELS.VIEW),
    },
  ];

  return (
    <>
      <Box sx={styles.box_breadcrumb_view}>
        <Breadcrumbs
          separator={GRN_BREADCRUMBS.SEPARATOR}
          aria-label="breadcrumb"
          sx={styles.breadcrumb}
        >
          <Link
            underline="hover"
            sx={styles.breadcrumb_link}
            // href=""
          >
            {GRN_BREADCRUMBS.HOME}
          </Link>
          <Link
            underline="hover"
            sx={styles.breadcrumb_link}
            // href=""
          >
            {GRN_BREADCRUMBS.MANAGEMENT}
          </Link>
          <Link
            sx={styles.breadcrumb_link_page}
            underline="hover"
            // href="#"
            aria-current="page"
          >
            {GRN_BREADCRUMBS.RETURN_APPROVE}
          </Link>
        </Breadcrumbs>
      </Box>

      <Box sx={styles.box_page_container}>
        <AppBar sx={styles.vg_appbar}>
          <Grid container spacing={2} sx={styles.appbar_grid_container}>
            <Grid
              size={{ xs: 12, sm: 4, md: 4, lg: 4, xl: 4 }}
              sx={styles.appbar_grid_container_col_1}
            >
              <Typography sx={styles.appbar_title}>
                {ViewApproverReturnGrnData.name}
              </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 8, md: 8, lg: 8, xl: 8 }}>
              <Box
                sx={{
                  gap: 1,
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                  

  {(() => {
    const selectedRows = filteredRows.filter((row) =>
      selectedIds.includes(row.id)
    );
    const hasStatus1 = selectedRows.some(
      (row) => String(row.trsts) === GRN_RETURN_PROCESS_STATUS.DIRECT_RETURN
    );
    const hasStatus2 = selectedRows.some(
      (row) => String(row.trsts) === GRN_RETURN_STATUS.DRAFT
    );
    const hasStatus3 = selectedRows.some(
      (row) => String(row.trsts) === GRN_RETURN_PROCESS_STATUS.APPROVAL_REQUIRED
    );

    return (
      <>
        {/* <Button
          variant="contained"
          color="primary"
          size="small"
          sx={{ ...styles.btn_primary }}
          onClick={handleReturnClick}
            disabled={!hasStatus1 && !hasStatus3}
        >
          Return
        </Button> */}

        <Button
          variant="contained"
          color="primary"
          size="small"
          sx={{ ...styles.btn_primary }}
          onClick={handleRejectClick}
          disabled={  !hasStatus3 && !hasStatus2}
        >
          Reject
        </Button>
        <Button
          variant="contained"
          color="primary"
          size="small"
          sx={{ ...styles.btn_primary }}
          onClick={handleApproveClick}
          disabled={ !hasStatus3 && !hasStatus2}
        >
          Approve
        </Button>
      </>
     );
  })()}
                {/* <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  sx={{ ...styles.btn_primary }}
                >
                  View
                </Button> */}
              </Box>
            </Grid>
            {/* <Grid
              size={{ xs: 12, sm: 12, md: 1, lg: 1, xl: 1 }}
              sx={styles.vg_grid_new_button}
            >
              <Button
                variant="contained"
                startIcon={<AddCircleOutlineIcon />}
                size="small"
                sx={{ ...styles.btn_primary, ...styles.btn_appbar_add }}
                onClick={goToCreateGrn}
              >
                New
              </Button>
            </Grid> */}
          </Grid>
        </AppBar>
        <FilterReturnGrnSearch
          warehouseOptions={warehouseOptions}
          grnStatusTypes={grnStatusTypes}
          onFilterChange={handleFilterChange}
           searchFields={SEARCH_FIELDS_RTNHISTORY}
        />

        <Box sx={styles.view_page_container}>
        <ViewDataGridGrn
  columns={ViewApproverReturnGrnData.columns}
  rows={isFilterApplied ? sortedFilteredFullRows : sortedFilteredRows}
  menuItems={menuItems}
  tabletitle={ViewApproverReturnGrnData.name}
  gridid={GRN_RETURN_APPROVAL_FILTER.GRID_ID}
  sx={styles.view_data_grid_page}
  onSelectionChange={handleRowSelection}
  grnStatusTypes={grnStatusTypes}
  grnReturnStatusTypes={undefined}
  selectionModel={selectedIds}
  showSkeletonWhenEmpty={false}  // ← disable skeleton so empty state shows
/>
        </Box>
      </Box>

      <ApprovalActionDialogreturn
        open={openApproveDialog}
        handleClose={() => setOpenApproveDialog(false)}
        actionType={BUTTON_LABELS.APPROVE}
        grnCodes={selectedGrnCode}
        rtncodes={selectedRtnCode}
        enUser={USERNAME}
        onSuccess={() => {
          fetchGrnListData(true); // Refresh data after status change (force refresh)
          setOpenApproveDialog(false);
          setSelectedIds([]);
          setSelectedGrnCode([]);
          setSelectedRtnCode([]);
          showSuccess(GRN_SUCCESS_MESSAGES.APPROVE_SUCCESS);
        }}
      />
      <ApprovalActionDialogreturn
        open={openReturnDialog}
        handleClose={() => setOpenReturnDialog(false)}
        actionType={BUTTON_LABELS.RETURN}
        grnCodes={selectedGrnCode}
        rtncodes={selectedRtnCode}
        enUser={USERNAME}
        onSuccess={() => {
          fetchGrnListData(true); // Refresh data after status change (force refresh)
          setOpenApproveDialog(false);
          setSelectedIds([]);
          setSelectedGrnCode([]);
          setSelectedRtnCode([]);
          showSuccess(GRN_SUCCESS_MESSAGES.RETURN_SUCCESS);
        }}
      />
      <ApprovalActionDialogreturn
        open={openRejectDialog}
        handleClose={() => setOpenRejectDialog(false)}
        actionType={BUTTON_LABELS.REJECT}
        grnCodes={selectedGrnCode}
        rtncodes={selectedRtnCode}
        enUser={USERNAME}
        onSuccess={() => {
          fetchGrnListData(true); // Refresh data after status change (force refresh)
          setOpenApproveDialog(false);
          setSelectedIds([]);
          setSelectedGrnCode([]);
          setSelectedRtnCode([]);
          showSuccess(GRN_SUCCESS_MESSAGES.REJECT_SUCCESS);
        }}
      />
      <SystemAlert
        open={alertOpen}
        type={alertType}
        message={alertMessage}
        onClose={() => setAlertOpen(false)}
      />
    </>
  );
};

export default ViewhoodReturnApproval;
